import { useCallback, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { LOGIN_REDIRECT_COOKIE_KEY } from '../../constants';
import {
  CookieActionType,
  CookieExpirationType,
  cookieOptions,
  getOrganisationDomain,
} from '../../utils';

export const useLoginRedirect = () => {
  const cookieKey = useMemo(() => `${LOGIN_REDIRECT_COOKIE_KEY}_${getOrganisationDomain()}`, []);

  const [cookies, setCookie, removeCookie] = useCookies([cookieKey]);

  const loginRedirect: string | undefined = cookies[cookieKey];

  const storeLoginRedirect = useCallback(() => {
    if (window.location.pathname.includes('/auth/')) {
      return;
    }

    setCookie(
      cookieKey,
      window.location.href,
      cookieOptions({ expiration: CookieExpirationType.DAY })
    );
  }, [cookieKey, setCookie]);

  const clearLoginRedirect = useCallback(() => {
    removeCookie(cookieKey, cookieOptions({ action: CookieActionType.REMOVE }));
  }, [cookieKey, removeCookie]);

  return { loginRedirect, storeLoginRedirect, clearLoginRedirect };
};
